import { RouteConfig } from 'vue-router';
const ZhanghuList = () => import('./views/zhanghu/list.vue');
const ZhanghuEdit = () => import('./views/zhanghu/edit.vue');
const DeviceManage = () => import('./views/device/manage.vue');
const routers: RouteConfig[] = [
    {
        path: 'zhanghu-list',
        name: 'zhanghu-list',
        component: ZhanghuList
    },
    {
        path: 'zhanghu-edit',
        name: 'zhanghu-edit',
        component: ZhanghuEdit
    },
    {
        path: 'device-manage',
        name: 'device-manage',
        component: DeviceManage
    },
    {
        path: '*',
        redirect: 'zhanghu-list'
    },
];
export default routers;

